import { useSelector } from "@tanstack/react-form";
import type { FieldOption } from "../../../types/form";
import { ReactSelect } from "../../form-fields/components/select/react-select";
import { Stack } from "../../stack";
import { useFieldContext } from "../form/form-context";
import { FieldInfo } from "./fieldinfo";

type SelectFieldProps = {
	label?: string;
	options: FieldOption[];
	isDisabled?: boolean;
	placeholder?: string;
	onBlur?: () => void;
	onChange?: (e: FieldOption | null) => void;
	floatingLabel?: true;
	menuPortalTarget?: HTMLElement | null | undefined;
};

export const SelectField = ({
	label,
	options,
	isDisabled,
	onChange,
	floatingLabel,
	menuPortalTarget = null,
	...props
}: SelectFieldProps) => {
	const field = useFieldContext<string>();
	const meta = useSelector(field.store, (state) => state.meta);

	const handleChange = (e: FieldOption | null) => {
		field.handleChange(e?.value || "");
		onChange?.(e);
	};

	return (
		<Stack gap={2}>
			<ReactSelect
				menuPortalTarget={menuPortalTarget}
				options={options}
				onChange={handleChange}
				label={label}
				hideSelectedOptions={false}
				value={options.find((o) => o.value === field.state.value) || null}
				floatingLabel={floatingLabel}
				onBlur={field.handleBlur}
				name={field.name}
				id={field.name}
				isDisabled={isDisabled}
				error={meta.errors.length > 0}
				{...props}
			/>
			<FieldInfo field={field} />
		</Stack>
	);
};
